import { render, staticRenderFns } from "./YougovPreferences.vue?vue&type=template&id=4aafc18f&scoped=true&"
import script from "./YougovPreferences.vue?vue&type=script&lang=js&"
export * from "./YougovPreferences.vue?vue&type=script&lang=js&"
import style0 from "./YougovPreferences.vue?vue&type=style&index=0&id=4aafc18f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aafc18f",
  null
  
)

export default component.exports